<template>
  <div class="editPassword">
    <van-cell-group inset>
      <div class="title">输入旧密码</div>
      <van-field
        v-model="data.oldPassword"
        placeholder="请输入旧的密码"
        maxlength="20"
        @input="data.input('oldPassword')"
        type="password"
      />
      <div class="title">输入新密码</div>
      <van-field
        v-model="data.newPassword"
        placeholder="请输入新的密码"
        @input="data.input('newPassword')"
        maxlength="20"
        type="password"
      />
      <div class="title">再次输入密码</div>
      <van-field
        v-model="data.copyNewPassword"
        placeholder="请再次输入密码"
        @input="data.input('copyNewPassword')"
        maxlength="20"
        type="password"
      />
      <div class="tip">6-20位密码，同时包含字母和数字</div>
    </van-cell-group>
    <div class="bottom">
      <div class="btn" @click="data.quitEdit">确认修改</div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  defineComponent,
  defineExpose,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { editPassword } from "@/api/login";
import { showSuccessToast, showFailToast } from "vant";
import { useCounterStore } from "@/store";
import cross from "@/assets/cross.png";
import surres from "@/assets/surres.png";
defineComponent({
  name: "",
});
const store = useCounterStore();
const route = useRoute();
const router = useRouter();
const data = reactive({});

data.oldPassword = "";

data.newPassword = "";

data.copyNewPassword = "";

data.validateData = [
  {
    key: "oldPassword",
    name: "请输入旧密码",
  },
  {
    key: "newPassword",
    name: "请输入新密码",
  },
  {
    key: "copyNewPassword",
    name: "两次输入的密码不一致",
    isEqual: true,
    equalKey: "newPassword",
  },
];

data.input = (e) => {
  data[e] = data[e].trim();
};

data.quitEdit = () => {
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/;
  for (let i = 0; i < data.validateData.length; i++) {
    const { key, name, isEqual, equalKey } = data.validateData[i];
    if (!data[key]) {
      showFailToast({
        message: `${name}`,
        icon: cross,
      });
      return;
    }
    if (data[key].length < 6) {
      showFailToast({
        message: "请输入\n6-20位密码",
        icon: cross,
      });
      return;
    }
    if (!passwordRegex.test(data[key])) {
      showFailToast({
        message: "密码需包含字母和数字",
        icon: cross,
      });
      return;
    }
    if (isEqual && data[key] !== data[equalKey]) {
      showFailToast({
        message: "两次输入的密码不一致",
        icon: cross,
      });
      return;
    }
  }
  editPassword({
    old:data.oldPassword,
    new:data.newPassword,
  }).then(res=>{
    if (res.code === 200) {
      store.getUserinfo(store.userInfo.id);
      showFailToast({
        message: "修改成功",
        icon: surres,
      });
      router.go(-1)
    }
  })
};

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});
watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.van-cell-group,
.van-field {
  background: transparent;
}
.van-field::after {
  display: none;
}
.van-field {
  font-size: 28px;
  width: auto;
  margin: 0 64px;
  padding: 12px 0;
  box-sizing: border-box;
  border-bottom: 2px solid #f7f5ff40;
  ::v-deep().van-field__control {
    color: #ffffff;
  }
}
.title {
  margin: 0 64px;
  margin-top: 64px;
  margin-bottom: 30px;
  font-weight: 400;
  color: #ffffff;
  font-size: 28px;
}
.tip {
  color: #f7f5ff60;
  font-size: 26px;
  margin: 0 64px;
  margin-top: 18px;
}
.bottom {
  margin: 0 64px;
  margin-top: 98px;
  .btn {
    background: #8368fc;
    border-radius: 44px;
    font-weight: 500;
    color: #ffffff;
    font-size: 30;
    text-align: center;
    padding: 23px 0;
  }
}
</style>
